import React from 'react';
import type { FieldValues, Path } from 'react-hook-form';
import { Controller, get, useFormContext } from 'react-hook-form';
import type { InputProps } from 'src/components/ui/input';
import { Input } from 'src/components/ui/input';
type RHFInputProps<T extends FieldValues> = {
  name: Path<T>;
  helperText?: string;
} & Omit<InputProps, 'name' | 'value' | 'onChange' | 'onBlur' | 'error'>;

export function RHFInput<T extends FieldValues>({
  name,
  helperText,
  ...inputProps
}: RHFInputProps<T>) {
  const {
    control,
    formState: { errors }
  } = useFormContext<T>();

  const fieldError = get(errors, name);
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Input
          error={!!fieldError}
          helperText={(fieldError?.message as string) || helperText}
          {...field}
          {...inputProps}
        />
      )}
    />
  );
}
